<div class="grid-x grid-margin-x teaser">
  <h1 class="cell text-center" [innerHTML]="('photovoltaikcheck.einstieg.stepheadline' + (pathBalcony? '.balkon' : '')) | translate: welcomePlaceholder"></h1>
  <div class="cell small-12 medium-offset-2 medium-3">
    <app-advisor-image path="/pvc/pvc-teaser.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
    <div class="callout" [innerHTML]="('photovoltaikcheck.einstieg.teaser' + (pathBalcony? '.balkon' : '')) | translate"></div>
    @if (pathBalcony) {
      <div class="callout lighter-gray show-for-large" [innerHTML]="'photovoltaikcheck.einstieg.balkon.teaser2' | translate"></div>
    }
  </div>
</div>

@if (!pathBalcony) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <fieldset class="grid-x grid-margin-x check-wrapper">
      <legend class="cell small-12 medium-offset-1 medium-10">{{ 'photovoltaikcheck.einstieg.selection.headline' | translate }}</legend>
      @for(interest of interestList; track interest) {
        <div class="cell small-12 medium-5">
          <div class="radio-button">
            <input type="radio" name="interesse" [id]="'interesse_' + interest" [value]="interest" formControlName="interesse" [attr.aria-expanded]="form?.get('interesse').value === interest" aria-controls="button-teaser">
            <label [for]="'interesse_' + interest" (click)="scrollDown()">
              <app-advisor-image [path]="'/pvc/pvc-einstieg-' + interest + '.svg'"></app-advisor-image>
              <span [innerHTML]="'photovoltaikcheck.einstieg.interesse.' + interest | translate"></span>
            </label>
          </div>
        </div>
      }
    </fieldset>

    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-offset-1 medium-10">
        <div id="button-teaser" class="button-wrapper" [class.background]="form?.get('interesse').valid" #submit>
          @if (form?.get('interesse').valid) {
            <div [innerHTML]="'photovoltaikcheck.einstieg.submit.teaser' | translate"></div>
          }
          @if (showError && form.valid === false) {
            <div role="alert" class="form-errors" [innerHTML]="'photovoltaikcheck.einstieg.submit.teaser.error' | translate"></div>
          }
          <button  type="submit" class="button inline-arrow-right" (click)="onSubmitClick()" [class.disabled]="!form.valid">{{ 'photovoltaikcheck.einstieg.submit' | translate }}</button>
        </div>
      </div>
    </div>
  </form>
} @else {
  <div class="grid-x grid-margin-x">
    <div class="cell small-12 medium-offset-1 medium-10">
      <div class="callout lighter-gray hide-for-large" [innerHTML]="'photovoltaikcheck.einstieg.balkon.teaser2' | translate"></div>

      <div class="button-wrapper background">
        <div [innerHTML]="'photovoltaikcheck.einstieg.buttonteaser.balkon' | translate"></div>
        <a [routerLink]="'../../eingabe/basisdaten/1'" class="button primary inline-arrow-right">{{'photovoltaikcheck.einstieg.submit' | translate}}</a>
      </div>
    </div>
  </div>
}
